// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class ShowView extends JQueryView {
  constructor() {
    super('.main-content');
    this.render();
  }

  scrollToLatestComment = () => {
    const target = $('.comment-list');
    target.scrollTop(target[0].scrollHeight);
  };

  @on({ event: 'click', selector: '#show-more-history-button' })
  showMoreDocumentHistory() {
    $('.history-file').each(function() {
      $(this).removeClass('d-none');
    });
    $('#show-more-history-button').addClass('d-none');
    $('.document-history-container').addClass('scrollable');
  }

  @on({ event: 'click', selector: '#show-more-reference-files-button' })
  showMoreReferenceFiles() {
    $('.reference-file').each(function() {
      $(this).removeClass('d-none');
    });
    $('#show-more-reference-files-button').addClass('d-none');
    $('.reference-files-container').addClass('scrollable');
  }

  render() {
    $('textarea').on('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });

    this.scrollToLatestComment();
  }
}
